import React from 'react'

export default function ProductOnHome() {
    return (
        <div class="col-9 container-fluid mt-5 border border-5 rounded">
            <h3>For a New Pet Dog: </h3>
            <ol>
                <li> Food and Water Bowls: Choose sturdy, non-tip bowls that are easy to clean.</li>
                <li> High-Quality Dog Food: Opt for a well-balanced, age-appropriate dog food recommended by your veterinarian.</li>
                <li>Collar and Leash: Ensure you have a properly fitted collar and a leash for walks and outdoor activities.</li>
                <li> ID Tags: Attach an identification tag with your contact information to your dog's collar.</li>
                <li> Comfortable Bed: Provide a cozy bed or crate mat for your dog's comfort.</li>
                <li>Crate or Kennel: A crate or kennel provides a safe space for your dog to rest and can aid in housetraining.</li>
                <li> Chew Toys: Choose appropriate chew toys to satisfy your dog's natural chewing instincts and promote dental health.</li>
                <li> Grooming Supplies: Include a brush or comb, dog shampoo, nail clippers, and ear cleaning solution.</li>
                <li> Poop Bags: Keep an ample supply of poop bags for responsible waste cleanup during walks.</li>
                <li>  Training Supplies: Consider treats, clicker, and training pads if you plan to train your dog at home.</li>
            </ol>


            <h3>For a New Pet Kitten:</h3>
            <ol>
                <li> Litter Box and Litter: Select a litter box with low sides for easy access and a litter type suitable for kittens.</li>
                <li> High-Quality Kitten Food: Choose a nutritionally balanced kitten food recommended by your veterinarian.</li>
                <li>Food and Water Bowls: Opt for shallow, non-tip bowls that are easy to clean.</li>
                <li> Scratching Post: Provide a scratching post or cat tree to satisfy your kitten's scratching needs.</li>
                <li>  Comfortable Bed: Offer a soft bed or cozy blanket for your kitten to curl up in.</li>
                <li>  Interactive Toys: Include toys that stimulate your kitten's natural hunting instincts, such as interactive wands and catnip toys.</li>
                <li>Grooming Supplies: Include a brush or comb suitable for your kitten's coat type and nail clippers.</li>
                <li>Carrier: A secure and well-ventilated carrier is essential for safe transportation to the veterinarian or during travel.</li>
                <li>Kitten-Proofing Supplies: Ensure your home is kitten-proofed with baby gates, cabinet locks, and cord protectors.</li>
                <li>Cat Collar and ID Tag: If you plan to let your kitten explore outdoors, consider a collar with an ID tag.</li>
            </ol>

        </div>
    )
}


